import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './DXIThreeUp.module.css';

const DXIThreeUp = ({ heading, mediaList, className = '' }) => {
  return (
    <div className={[styles.results, className].join(' ')}>
      <h3>{heading}</h3>
      <div className={styles.resultsGrid}>
        {mediaList.map((card, i) => {
          return (
            <div className={styles.card} key={i}>
              {card.file?.contentType === 'image/svg+xml' ? (
                <img src={card.file.url} alt={card.title} className={styles.cardImage} />
              ) : (
                <GatsbyImage
                  data-ot-ignore
                  style={{ height: '100%', width: '100%' }}
                  imgStyle={{ objectFit: 'contain' }}
                  imgClassName={styles.cardImage}
                  alt={card.title}
                  image={card.gatsbyImageData}
                />
              )}
              <div>
                <h4>{card.title}</h4>
                <p>{card.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

DXIThreeUp.propTypes = {
  heading: PropTypes.string.isRequired,
  mediaList: PropTypes.array.isRequired,
  className: PropTypes.string,
};

export default DXIThreeUp;
